var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95 90",
    style: {
      enableBackground: "new 0 0 95 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000121992900668230936030000001322061126077168268_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.6946,
    y1: 23.0116,
    x2: 85.8275,
    y2: 93.4234,
    gradientTransform: "matrix(1 0 0 -1 0 91.9139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED8E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DF2B26"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.71,20.7c0,9.68-12.98,18.48-12.98,18.48L42.82,19.6L25.66,65.7c0,0,21.61-0.98,40.27-13.2 C81.14,42.52,88.3,31.92,88.3,23.34c0-6.16-4.72-19.14-25.79-19.14c-23.21,0-33.45,9.57-33.45,9.57S40.51,8.6,56.13,8.6 C64.05,8.6,76.71,11.02,76.71,20.7z M47.99,47.87c-4.29,1.65-7.81,2.64-7.81,2.64l5.5-14.85l9.46,8.91 C55.14,44.57,52.28,46.22,47.99,47.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165209041277490494240000006936866807735068851_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.0078,
    y1: 15.1042,
    x2: 93.1407,
    y2: 85.5161,
    gradientTransform: "matrix(1 0 0 -1 0 91.9139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED8E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DF2B26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165209041277490494240000006936866807735068851_)"
    },
    d: "M68.6,64.23 c-7.26,5.5-18.12,11.81-32.71,11.81c-19.66,0-22.59-15.18-22.59-21.05s1.17-11.44,6.09-19.33s13.5-14.71,13.5-14.71 s-5.79,3.3-8.43,5.57C21.81,28.8,6.7,40.61,6.7,60.05s15.75,25.89,29.25,25.89c11.66,0,24.52-5.06,34.71-15.26 c10.2-10.2,13.5-23.73,13.5-23.73S77.4,57.56,68.6,64.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAe);
export default __webpack_public_path__ + "static/media/ae.18d1c122dd39d26b0fff7767a64fc629.svg";
export { ForwardRef as ReactComponent };